import { createSelectField } from 'components/fields/createSelectField';
import { OutletOrServiceCategoryTitle } from './OutletOrServiceCategoryTitle';
import type { OutletOrServiceCategory } from './types';

type T = Omit<OutletOrServiceCategory, 'category' | 'vendor_id'>;
export const outletOrServiceCategoryFieldProps = {
  getOptionLabel: ({ name }: T) => name,
  formatOptionLabel: OutletOrServiceCategoryTitle,
  getOptionValue: (a: T) => a.id.toString(),
};

export const OutletOrServiceCategoryField = createSelectField<T>('supplier/outlet_or_service_category/', {
  ...outletOrServiceCategoryFieldProps,
  suggestion: true,
});
